/** What a search means: surrounding spaces dropped, inner runs of spaces as one. A box of only spaces is empty. */
export const normalizeSearch = (text: string) => text.trim().replace(/\s+/g, ' ')
